import * as firebase from 'firebase';
import firestore from 'firebase/firestore'

const settings = {timestampsInSnapshots: true};

const config = {
  apiKey: "AIzaSyCqCWWiuoVN1CHsLTyA2OsCPPXmTD0CM2U",
  authDomain: "easysuki-prod.firebaseio.com",
  databaseURL: "https://easysuki-prod.firebaseio.com",
  projectId: "easysuki-prod",
  storageBucket: "easysuki-prod.appspot.com"
};
firebase.initializeApp(config);

firebase.firestore().settings(settings);

export default firebase;